import { render, staticRenderFns } from "./FilterTreeGrade.vue?vue&type=template&id=c4ff9f0c&scoped=true"
import script from "./FilterTreeGrade.vue?vue&type=script&lang=js"
export * from "./FilterTreeGrade.vue?vue&type=script&lang=js"
import style0 from "./FilterTreeGrade.vue?vue&type=style&index=0&id=c4ff9f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ff9f0c",
  null
  
)

export default component.exports